export default "__VITE_ASSET__B_mhy$dY__"